const types = {
    SET_REPLENISHMENT_REPORT: '[REPLENISHMENT REPORT] SET REPLENISHMENT REPORT',
    SET_REPLENISHMENT: '[REPLENISHMENT] SET REPLENISHMENT',
}

export {
    types
}